<div class="offer">
  <div class="offer_icon"><i class="fab fa-amazon"></i></div>
  <div class="offer_amount">{{ params.data.OffersFba | number}}</div>
</div>

<div class="offer">
  <div class="offer_icon"><i class="fal fa-home-lg-alt"></i></div>
  <div class="offer_amount">{{ params.data.OffersFbm | number}}</div>
</div>
